import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {Account, NewAccount} from './accounts.iface'
import {environment} from '../../../environments/environment'
import {ApiListResponse} from '../../shared/interfaces/common'
import {AuthService} from '../../shared/services/auth.service'

@Injectable()
export class AccountsService {

  getAllAccounts(): Promise<Account[]> {
    return new Promise((resolve, reject) => {
      const impersonatedCompany = this.auth.isImpersonating()
        ? this.auth.getImpersonatedCompany()
        : null
      const adminId = impersonatedCompany?.adminId
      const url = adminId
        ? `${environment.ipiUrl}api/admin/all?adminId=${encodeURIComponent(adminId)}`
        : `${environment.ipiUrl}api/admin/all`
      this.http.get<ApiListResponse<Account>>(url)
        .subscribe((res) => {
          resolve(res.results)
      }, error => {
          reject(error)
        })
    })
  }
  getAccount(aid: string | number): Promise<Account> {
    return new Promise((resolve, reject) => {
      this.http.get<Account>(`${environment.ipiUrl}api/admin/${aid}`)
        .subscribe((res) => {
          resolve(res)
      }, error => {
          reject(error)
        })
    })
  }


  addNewAccount(data: NewAccount): Promise<Account> {
    return new Promise((resolve, reject) => {
      this.http.post<Account>(`${environment.ipiUrl}api/admin`, data)
        .subscribe((res) => {
          resolve(res)
        }, error => {
          reject(error)
        })
    })
  }

  editAccount(data: NewAccount): Promise<Account> {
    return new Promise((resolve, reject) => {
      this.http.put<Account>(`${environment.ipiUrl}api/admin/${data.adminId}`, data)
        .subscribe((res) => {
          resolve(res)
        }, error => {
          reject(error)
        })
    })
  }

  constructor(private http: HttpClient, private auth: AuthService) {
  }
}
